import PropTypes from "prop-types";
import React, {PureComponent} from "react";
import {YMaps, Map, Polygon, Placemark} from "react-yandex-maps";
import {connect} from "react-redux";

import {PIN_SIZE, MapColor, ResearchTitle, Research} from "../const";
import {CatchAreaPropType, PoolPropType} from "../prop-types";
import {applyMobileMap, extend, getAreaTotalResearches} from "../utils/utils";
import {getActiveArea, getActivePool} from "../reducers/data/selectors";
import {getActiveDataMode} from "../reducers/application/selectors";


const MapMode = extend(Research, {
  TOTAL: `TOTAL`,
  LINKS: `LINKS`,
});

const getOffset = (element) => {
  return {
    offsetHeight: element.getBoundingClientRect().height / 2 + PIN_SIZE[1] / 2,
    offsetWidth: PIN_SIZE[0] / 2 + 15,
  };
};

const getTotalResearchTemplate = (areaResearches) => {
  return areaResearches.map((research) => {
    const researchTitle = ResearchTitle[research.name].title.replace(`в том числе `, ``);
    const researchAmount = research.totalAmount;
    const researchAmountNotMatch = research.totalAmountNotMatch;
    const isDetails = research.isDetails;

    return (
      `<tr class="research__data  research__data--research-balloon">
        <td class="research__description  research__description--research-balloon">
          ${researchTitle}
          ${isDetails && `<button class="research__toggle  balloon-toggle" type="button" data-research-name=${research.name}>Подробнее</button>` || ``}
        </td>
        <td class="research__amount  research__amount--research-balloon">${researchAmount}</td>
        <td class="research__amount-not-match  research__amount-not-match--research-balloon">${researchAmountNotMatch}</td>
      </tr>`
    );
  }).join(``);
};

const getDetailedResearchTemplate = (researchs) => {
  return researchs.map((researchItem) => (
    `<tr class="research__data  research__data--research-balloon">
      <td class="research__description  research__description--research-balloon">${researchItem.title}</td>
      <td class="research__amount  research__amount--research-balloon">${researchItem.amount}</td>
      <td class="research__amount-not-match  research__amount-not-match--research-balloon">${researchItem.notMatch}</td>
    </tr>`
  )).join(``);
};

const getResearchLinksTemplate = (links) => {
  const linksTemplate = links.map((link) => (
    `<li class="research__list-item  research__list-item--research-balloon">
      <a class="research__link  research__link--research-balloon" href="${link.url}" target="_blank">${link.title}</a>
    </li>`
  )).join(``);

  return (
    `<ul class="research__list  research__list--research-balloon">
      ${linksTemplate}
    </ul>`
  );
};

const getResearchBalloonTemplate = (area, dataMode, mapMode, currentResearch) => {
  const areaResearches = getAreaTotalResearches(area, dataMode);

  if (mapMode === MapMode.TOTAL) {
    const totalResearchTemplate = getTotalResearchTemplate(areaResearches);

    return (
      `<div class="research-balloon">
          <h5 class="research-balloon__title">${area.title}</h5>

          <button class="research-balloon__close-button">
            <span class="visually-hidden">Закрыть</span>
          </button>

          <p class="research-balloon__intro">Общее количество исследований в районе вылова</p>

          <div class="research-balloon__research  research  research--research-balloon">
            <div class="research__wrapper  research__wrapper--research-balloon">
              <table class="research__info  research__info--research-balloon">
                <tr class="research__head  research__head--research-balloon">
                  <th class="research__description  research__description--research-balloon">Исследование</th>
                  <th class="research__amount  research__amount--research-balloon">Проведено исследований</th>
                  <th class="research__amount-not-match  research__amount-not-match--research-balloon">Не соответствует нормам</th>
                </tr>

                ${totalResearchTemplate}
              </table>
            </div>
          </div>
      </div>`
    );
  } else if (mapMode === MapMode.LINKS) {
    const toggleDataResearchName = currentResearch;
    let links = null;

    area.sources.forEach((source) => {
      if (source.dataMode === dataMode && source.name === currentResearch) {
        links = source.researchSources;
      }
    });

    const reserchLinksTemplate = getResearchLinksTemplate(links);

    return (
      `<div class="research-balloon">
        <h5 class="research-balloon__title">${area.title}</h5>

        <button class="research-balloon__close-button">
          <span class="visually-hidden">Закрыть</span>
        </button>

        <p class="research-balloon__intro">Протоколы исследований</p>

        <div class="research-balloon__research  research  research--research-balloon">
          <div class="research__wrapper  research__wrapper--research-balloon">
            <div class="research__info  research__info--research-balloon">
              ${reserchLinksTemplate}
            </div>
          </div>
        </div>

        <button class="research-balloon__toggle  balloon-toggle  balloon-toggle--bottom" type="button" data-research-name=${toggleDataResearchName}>Назад к исследованиям</button>
      </div>`
    );
  } else {
    let intro = ``;
    let description = ``;
    const toggleDataResearchName = MapMode.TOTAL;
    const toogleToLinksName = MapMode.LINKS;
    const isSources = areaResearches.find((research) => research.name === mapMode).researchSources.length;
    const researchTemplate = getDetailedResearchTemplate(area.researches.filter((research) => research.name === mapMode && research.dataMode === dataMode));

    switch (mapMode) {
      case MapMode[Research.PATHOGENS]: {
        intro = `По возбудителям болезни`;
        description = `Перечень заразных<br/>болезней`;
        break;
      }
      case MapMode[Research.PARASITOLOGICAL]: {
        intro = `По паразитологическим показателям безопасности`;
        description = `Перечень паразитологических<br/>показателей`;
        break;
      }
      case MapMode[Research.CHEMICAL_TOXICOLOGICAL]: {
        intro = `По химико-токсикологическим показателям`;
        description = `Перечень химико-токсикологических показателей`;
        break;
      }
    }

    return (
      `<div class="research-balloon">
          <h5 class="research-balloon__title">${area.title}</h5>

          <button class="research-balloon__close-button">
            <span class="visually-hidden">Закрыть</span>
          </button>

          ${isSources && `<button class="research-balloon__toggle  balloon-toggle  balloon-toggle--top" type="button" data-research-name=${toogleToLinksName}>${intro}</button>`
          || `<p class="research-balloon__intro">${intro}</p>`}

          <div class="research-balloon__research  research  research--research-balloon">
            <div class="research__wrapper  research__wrapper--research-balloon">
              <table class="research__info  research__info--research-balloon">
                <tr class="research__head  research__head--research-balloon">
                  <th class="research__description  research__description--research-balloon">${description}</th>
                  <th class="research__amount  research__amount--research-balloon">Проведено исследований</th>
                  <th class="research__amount-not-match  research__amount-not-match--research-balloon">Не соответствует нормам</th>
                </tr>

                ${researchTemplate}
              </table>
            </div>
          </div>

          <button class="research-balloon__toggle  balloon-toggle  balloon-toggle--bottom" type="button" data-research-name=${toggleDataResearchName}>Назад к общему количеству исследований</button>
      </div>`
    );
  }
};

const createResearchBalloonLayout = (ymaps, activeArea, mapMode, dataMode, currentResearch, onResearchToggleClick, onResearchLinkClick) => {
  const researchBalloonTemplate = getResearchBalloonTemplate(activeArea, dataMode, mapMode, currentResearch);

  return (
    ymaps.templateLayoutFactory.createClass(
        researchBalloonTemplate, {

          build() {
            this.constructor.superclass.build.call(this);

            this._balloon = document.querySelector(`.research-balloon`);

            this._applyElementOffset.call(this);
            this._correctBalloonWidth.call(this);

            this._balloon.querySelector(`.research-balloon__close-button`)
              .addEventListener(`click`, this._handleCloseClick.bind(this));

            const researchToggles = this._balloon.querySelectorAll(`.balloon-toggle`);
            if (researchToggles.length) {
              researchToggles.forEach((toggle) => toggle.addEventListener(`click`, onResearchToggleClick));
            }

            const researchLinks = this._balloon.querySelectorAll(`.research-balloon__intro--link`);
            if (researchLinks.length) {
              researchLinks.forEach((link) => link.addEventListener(`click`, onResearchLinkClick));
            }
          },

          getShape() {
            const el = this.getElement();
            let result = null;
            if (el) {
              const firstChild = el.firstChild;
              const offset = getOffset(firstChild);

              result = new ymaps.shape.Rectangle(
                  new ymaps.geometry.pixel.Rectangle([
                    [offset.offsetWidth, -offset.offsetHeight],
                    [offset.offsetWidth + firstChild.offsetWidth, firstChild.offsetHeight - offset.offsetHeight]
                  ])
              );
            }
            return result;
          },

          _applyElementOffset() {
            const balloon = this.getParentElement().querySelector(`.research-balloon`);
            const offset = getOffset(balloon);
            balloon.style.transform = `translate(${offset.offsetWidth}px, ${-offset.offsetHeight}px)`;
          },

          _handleCloseClick(evt) {
            evt.preventDefault();
            this.events.fire(`userclose`);
          },

          _correctBalloonWidth() {
            const balloon = this.getParentElement().querySelector(`.research-balloon`);
            const research = balloon.querySelector(`.research`);
            const researchInfo = balloon.querySelector(`.research__info`);
            const researchWrapperHeight = this.getParentElement().querySelector(`.research__wrapper`).getBoundingClientRect().height;
            const researchInfoHeight = researchInfo.getBoundingClientRect().height;

            if (researchInfoHeight > researchWrapperHeight) {
              balloon.classList.add(`research-balloon--scroll`);
              research.classList.add(`research--scroll`);
              researchInfo.classList.add(`research__info--scroll`);
            }
          },
        }
    )
  );
};


class MapPoolComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      ymaps: null,
      mapMode: MapMode.TOTAL,
      areaId: this.props.area ? this.props.area.id : null,
      currentResearch: ``,
    };

    this._mapRef = React.createRef();
    this._poolRef = React.createRef();
    this._areaRef = React.createRef();

    this._getMapState = this._getMapState.bind(this);
    this._handleMapLoad = this._handleMapLoad.bind(this);
    this._applyMap = this._applyMap.bind(this);
    this._applyArea = this._applyArea.bind(this);
    this._setMapMode = this._setMapMode.bind(this);
    this._handleRresearchToggleClick = this._handleRresearchToggleClick.bind(this);
    this._handlePoolPolygonLoad = this._handlePoolPolygonLoad.bind(this);
  }

  componentDidUpdate() {
    const oldAreaId = this.state.areaId;
    const newAreaId = this.props.area ? this.props.area.id : null;

    if (oldAreaId !== newAreaId) {
      this.setState({
        mapMode: MapMode.TOTAL,
        areaId: newAreaId,
      });

      this._applyMap();
    }
  }

  _getMapState(pool) {
    return {
      center: pool.coordinates[0][0],
      controls: [],
      zoom: 3,
      checkZoomRange: true,
    };
  }

  _handleMapLoad(newYmaps) {
    this.setState({
      ymaps: newYmaps,
    });
  }

  _applyMap() {
    const ymaps = this.state.ymaps;
    const myMap = this._mapRef.current;
    const poolGeoObject = this._poolRef.current;
    const poolBounds = poolGeoObject.geometry.getBounds();
    const centerX = poolBounds[0][0] + (poolBounds[1][0] - poolBounds[0][0]) / 2;
    const centerY = poolBounds[1][1] > 0
      ? poolBounds[0][1] + (poolBounds[1][1] - poolBounds[0][1]) / 2
      : poolBounds[0][0] + (360 + poolBounds[1][0] - poolBounds[0][0]) / 2;

    const applyArea = this._applyArea;

    ymaps.ready(function () {
      myMap.setCenter([centerX, centerY]);
      myMap.setBounds(poolBounds);

      applyArea();

      applyMobileMap(myMap);
    });
  }

  _applyArea() {
    const areaGeoObject = this._areaRef.current;

    if (areaGeoObject) {
      areaGeoObject.balloon.open(areaGeoObject.geometry.getBounds());
      areaGeoObject.balloon.autoPan();
    }
  }

  _setMapMode(newMapMode) {
    let newCurrentResearch = ``;

    switch (newMapMode) {
      case MapMode.TOTAL:
        break;
      case MapMode.LINKS:
        newCurrentResearch = this.state.currentResearch;
        break;
      default:
        newCurrentResearch = newMapMode;
    }

    this.setState({
      mapMode: MapMode[newMapMode],
      currentResearch: newCurrentResearch,
    });
  }

  _handleRresearchToggleClick(event) {
    const researchName = event.target.dataset.researchName;
    this._setMapMode(researchName);
  }

  _handlePoolPolygonLoad() {
    this._applyMap();
  }

  render() {
    const pool = this.props.pool;
    const area = this.props.area;
    const dataMode = this.props.dataMode;
    const currentResearch = this.state.currentResearch;
    const mapMode = this.state.mapMode;
    const myYmaps = this.state.ymaps;
    const mapState = this._getMapState(pool);

    const researchBalloonLayout = area && myYmaps ? createResearchBalloonLayout(myYmaps, area, mapMode, dataMode, currentResearch, this._handleRresearchToggleClick, this._handleResearchLinkClick) : null;

    return (
      <section className="map">
        <div className="map__container">
          <h2 className="visually-hidden">Интерактивная карта</h2>

          <div className="map__interactive" id="ymap-pool">
            <YMaps
              query={{
                ns: `ymaps`,
                apikey: `03a72576-6326-46dd-9558-d211c7a8a216&lang=ru_RU`,
                load: `package.full`,
              }}
            >
              <Map
                instanceRef={this._mapRef}
                state={mapState}
                width={`100%`}
                height={`100%`}
                options={{
                  avoidFractionalZoom: false,
                  restrictMapArea: [[0, -89], [85, -90]],
                  suppressMapOpenBlock: true,
                  yandexMapDisablePoiInteractivity: true,
                }}
                onLoad= {(ymaps) => this._handleMapLoad(ymaps)}
              >
                <Polygon
                  instanceRef={this._poolRef}
                  geometry={pool.coordinates}
                  properties={{}}
                  options={{
                    fillColor: MapColor.FILL_COLOR,
                    fillOpacity: 0.2,
                    strokeColor: MapColor.STROKE_COLOR,
                    strokeWidth: 1,
                    strokeStyle: `solid`,
                  }}
                  onLoad={this._handlePoolPolygonLoad}
                />

                {
                  area && myYmaps &&
                  <Placemark
                    instanceRef={this._areaRef}
                    geometry={area.coordinates}
                    properties={{}}
                    options={{
                      iconLayout: `default#image`,
                      iconImageHref: `../../../../assets/img/pin.svg`,
                      iconImageSize: PIN_SIZE,
                      iconImageOffset: [-PIN_SIZE[0] / 2, -PIN_SIZE[1]],
                      balloonLayout: researchBalloonLayout,
                      hideIconOnBalloonOpen: false,
                    }}
                  />
                }
              </Map>
            </YMaps>
          </div>
        </div>
      </section>
    );
  }
}


MapPoolComponent.propTypes = {
  pool: PoolPropType.isRequired,
  area: CatchAreaPropType,
  dataMode: PropTypes.string.isRequired,
};


const mapStateToProps = (state) => ({
  pool: getActivePool(state),
  area: getActiveArea(state),
  dataMode: getActiveDataMode(state),
});

const MapPool = connect(mapStateToProps)(MapPoolComponent);


export {
  MapPoolComponent,
  MapPool,
};
